<template>
  <div class="box-border flex items-center h-screen w-screen  
        justify-center bg-gradient-to-l 
        from-teal-600 to-blue-900">
    <slot />
  </div>
</template>

<script lang="ts" setup>

</script>

<style></style>